module.exports = __webpack_public_path__ + "resources/3915a476e2a284486169827114c529c6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/starter.png
// module id = 221
// module chunks = 0